module.exports = __webpack_public_path__ + "img/logo.9bd7d971.svg";